// FOR ALL
//import vue from 'vue';

/*
import $ from 'jquery'

// Load Dependencies...
import lozad from 'lozad';
//var $ = require("jquery");
typeof window !== "undefined" ? window : this;
window.jQuery   = require('jquery');
window.$        = window.jQuery;
import 'slick-carousel'

const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

import './homepage-slick';

//require('./bootstrap');

*/


var $ = require('jquery');
window.$ = $;
window.jQuery = $;
require('bootstrap');
require('select2');
require('slick-carousel');
require('lightbox2');
//Doesn't work
//require('intl-tel-input/src');
//import 'intl-tel-input/build/js/intlTelInput.js';
//require('./vendors/intlTelInput.min.js');
require('./ajax');
require('./login-ajax');
require('@fancyapps/fancybox');
import './map';

import flatpickr from "flatpickr";

import lozad from 'lozad';
window.Lozad = lozad(); // lazy loads elements with default selector as '.lozad'
window.Lozad.observe();

window.addEventListener('pageChanged', event => {
    window.Lozad.observe();
    window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
});

window.addEventListener('lozadObserve', event => {
    window.Lozad.observe();
});

window.addEventListener('scrollToDevelopments', event => {
    window.scroll({
        top: $("#searchResults").first().offset().top - 130,
        left: 0,
        behavior: 'smooth'
    });
});

$('#shareModal').on('show.bs.modal', function (event) {
    $(this).find('#sharetype').text($(event.relatedTarget).data('type'));
});

$(".hamburger").click(function(){$(".hamburger").toggleClass("is-active")});$(".search-toggle").click(function(){$(".search-wrap").toggleClass("is-active")});

$('.select2-client-pages').select2({
    minimumResultsForSearch: Infinity,
});

// Smooth-scroll for [data-scroll] / [data-scroll-600] anchor links is handled
// natively by the inline click delegate in resources/views/frontend/_partials/scripts.blade.php
// (and CSS `html { scroll-behavior: smooth }` as a fallback). The previous
// cferdinandi/smooth-scroll library + new SmoothScroll(...) calls were removed
// 2026-05-19 as part of Phase 1 #8.

// Example starter JavaScript for disabling form submissions if there are invalid fields
(function() {
    'use strict';
    window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
                var this_form_buttons = $(form).find(':button,:submit');
                // Disable this form's buttons
                this_form_buttons.prop({'disabled':true,'title':'Processing...'}).addClass('disabled');
                if (form.checkValidity() === false) {
                    // Form not validated: re-enable this form's buttons
                    this_form_buttons.prop({'disabled':false,'title':''}).removeClass('disabled');
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();

$(document).ready(function()
{

    // Scroll Animate
    $('a.linkSlide').click(function(){
      $('html, body').animate({
        scrollTop: $( $.attr(this, 'href') ).offset().top - 100
      }, 800);
      return false;
    });

    // Market Valuation
    $('.accept-list-property').click(function()
    {
        var token = $('meta[name="csrf-token"]').attr('content');
        var client_valuation_id = $('.client_valuation_id').val();

        $.ajax(
            {
                type: 'POST',
                url: '/valuation-report/accept',
                data: { _token: token, client_valuation_id: client_valuation_id },
                success: function( data )
                {
                    if(data.success == true)
                    {
                        $('.list-property').html('<i class="fa fa-check u-inline-block"></i> <span class="f-black">Accepted</span>');
                        $('.recommended').hide();

                        $('.response-message').show().html(data.message);
                        $('#list-property-modal').modal('hide');
                    }
                }
            }
        )

        return false;
    })
})

require ('./datetimepickers');

// Sticky Headers
$(window).scroll( function()
{
    var market_price = $('.market-price');
    var header_height = $('.navbar').outerHeight();

    if(market_price.length > 0)
    {
        if($(this).scrollTop() >= $('.market-price').position().top)
        {
            $('.market-price').addClass('-scroll');
            $('.market-price').css('top', header_height);
        }

        if($(window).scrollTop() === 0)
        {
            $('.market-price').removeClass('-scroll');
        }
    }
});

require('./maps/leaflet');

if($('.highlights-gallery').length) {
    $('.highlights-gallery').slick({
        dots: true,
        infinite: true,
        speed: 500,
        cssEase: 'linear'
    });
}

if($('.slick-center').length) {
    $('.slick-center').slick({
        centerMode: true,
        dots: true,
        infinite: true,
        centerPadding: '200px',
        slidesToShow: 1,
        appendArrows: '.slick-center-nav',
        appendDots: '.slick-center-nav',
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    centerPadding: '40px',
                }
            }
        ]
    });
}

$('[data-fancybox="gallery"]').fancybox({
    buttons: [
        "slideShow",
        "thumbs",
        "close"
    ],
    loop: true
});

if ($('#developmentenquiry #phone').length) {
    var input = document.querySelector("#phone");
    var preferred_countries = document.querySelector('#preferred_countries').value.split(",");
    var dc = document.querySelector("#dial_code");
    var telephone_input = window.intlTelInput(input, {
        initialCountry: (preferred_countries.length && preferred_countries[0] != "") ? preferred_countries[0] : 'GB',
        //preferredCountries: ["gb","ie","be", "dk", "no", "se"]
        preferredCountries: (preferred_countries.length && preferred_countries[0] != "") ? preferred_countries : ["gb","ie","be", "dk", "no", "se"]
    });

    var updateDialCode = function() {
        var countryData = telephone_input.getSelectedCountryData();
        if(dc) {
            dc.value = countryData.dialCode;
        }
    };

    input.addEventListener("countrychange", updateDialCode);
    updateDialCode();
}

let singleDevelopmentTemplate2HeroSlider = $('.single-development-template-2 .hero-slider');

if (singleDevelopmentTemplate2HeroSlider.length) {
    singleDevelopmentTemplate2HeroSlider.slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $('.single-development-template-2 .hero-slider-container .hero-slider-nav').removeClass('active');
        $(`.single-development-template-2 .hero-slider-container .hero-slider-nav[data-slide=${nextSlide}]`).addClass('active');
        $('.single-development-template-2 .hero-slider-container .current-slide-indicator').text(String(nextSlide + 1).padStart(2, '0'));
    });

    $('.single-development-template-2 .hero-slider-container .hero-slider-nav').on('click', function(e) {
        e.preventDefault();
        let $this = $(this);
        let slide = $this.data('slide');
        $('.single-development-template-2 .hero-slider-container .single-development-template-2 .hero-slider-nav').removeClass('active');
        $this.addClass('active');
        singleDevelopmentTemplate2HeroSlider.slick('slickGoTo', slide);
        $('.single-development-template-2 .hero-slider-container .current-slide-indicator').text(String(slide + 1).padStart(2, '0'));
    });
}

let propertyShowcaseSlider = $('.property-showcase-slider');
let propertyPopupSlider = $('.property-popup-slider');

if (propertyShowcaseSlider.length) {
    propertyPopupSlider.slick({
        infinite: true,
        centerMode: false,
        slidesToShow: 1,
        variableWidth: false,
        dots: false,
        prevArrow: '<i class="slider-arrow prev-arrow"></i>',
        nextArrow: '<i class="slider-arrow next-arrow"></i>'
    });
    propertyShowcaseSlider.slick({
        infinite: true,
        centerMode: true,
        slidesToShow: 1,
        variableWidth: true,
        dots: true,
        prevArrow: '<i class="fa fa-chevron-left prev-arrow"></i>',
        nextArrow: '<i class="fa fa-chevron-right next-arrow"></i>'
    });
}
